import { AdPreviewOverideStylesByKey } from './shared';

const IndicatorWidth = 10;
const IndicatorsGap = 8;

const getIndicatorsWidth = placements => (placements * IndicatorWidth) + ((placements - 1) * IndicatorsGap);

export const getAdAssetsPreviewStyles = () => ({
  container: {
    position: 'sticky',
    top: '0',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: 'fit-content',
    maxWidth: '100%',

    '& .auto-height': {
      '& .carousel-inner': {
        height: 'auto !important',
      },
    },
    '& .use-custom-carousel': {
      '& .carousel-wrapper': {
        display: 'flex',
        justifyContent: 'center',

        '& .custom-carousel-controls-and-indicators': {
          bottom: '0 !important',
          margin: 'unset !important',
        },

        '& .carousel-control': {
          position: 'absolute !important',
          margin: '12px 0 !important',
          left: '50% !important',
          bottom: '16px !important',
        },

        '& .carousel-indicators': {
          position: 'absolute !important',
          left: '50% !important',
          margin: '48px 0 !important',
          transform: 'translateX(-50%) !important',
          gap: '8px !important',
          bottom: '0 !important',
        },
      },
    },
    '& .new-preview-carousel-container-adprelib': {
      backgroundColor: '#ffffff',
      border: 'none',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.10)',
      maxWidth: '420px',
      minWidth: 'unset !important',

      '& .ad-placement-card-preview.mma_191x100': {
        '& .card-parent': {
          maxWidth: AdPreviewOverideStylesByKey.mma_191x100.imagePreviewWidth,
        },
      },

      '& .ad-placement-card-preview.edge_178x100': {
        '& .card-parent': {
          '& .placement-card-content': {
            height: 'fit-content',
            width: 'fit-content',
            maxWidth: '100%',
            '& .text-container': {
              maxWidth: 'calc(100% - 25px)',
            },
          },
        },
      },

      '& .ad-placement-card-preview.msan_191x100': {
        '& .card-parent': {
          maxWidth: AdPreviewOverideStylesByKey.msan_191x100.imagePreviewWidth,
        },
      },

      '& .ad-placement-card-preview.msan_150x100': {
        '& .card-parent': {
          maxWidth: AdPreviewOverideStylesByKey.msan_150x100.imagePreviewWidth,
        },
      },

      '& .ad-placement-card-preview.msan_1x1': {
        padding: 20,
      },
      '& .ad-placement-card-preview.mma_4x1': {
        padding: 20,
      },
      '& .ad-placement-card-preview.mma_1x2': {
        padding: 20,
        maxWidth: AdPreviewOverideStylesByKey.mma_1x2.imagePreviewWidth,
      },
      '& .ad-placement-card-preview.msan_133x100': {
        padding: 20,
      },

      '& .ad-placement-card-preview.outlook_text_mobile': {
        boxSizing: 'content-box',
        maxWidth: 'calc(100% - 50px)',
      },

      '& .ad-placement-card-preview.outlook_text_web': {
        padding: '0px 8px',
      },
    },
  },
  'container-l': {
    '& .new-preview-carousel-container-adprelib': {
      width: '100%',
    },
  },
  'container-m': {
    '& .new-preview-carousel-container-adprelib': {
      width: '100%',
    },
  },
  'container-s': {
    '& .new-preview-carousel-container-adprelib': {
      width: '100%',
    },
  },
  adExtensionContainer: {
    // todo: add styles for ad extension preview components if needed
    margin: 10,
  },
  placementContainerClassName: {
    opacity: '100%',
  },
  carouselLayoutHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& .carousel-header-texts': {
      width: '100%',
      height: 24,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      margin: '20px 8px 16px 24px',
      fontSize: 18,
      fontWeight: 'normal',
      lineHeight: '24px',
      '& .carousel-header-ratio': {
        color: 'rgb(50, 49, 48)',
        fontSize: 14,
        fontWeight: 700,
        marginRight: 8,
      },
      '& .carousel-header-title': {
        fontSize: 14,
      },
    },
    '& .ad-preview-actions': {
      flexGrow: 0,
      textAligh: 'center',
      marginRight: 16,
      textWrap: 'nowrap',
    },
  },
  customCarouselClassName: {
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 4px 0px',
    '& .carousel-inner': {
      minHeight: 450,
    },

    '& .carousel-indicators': {
      display: 'flex !important',
      left: '50% !important',
      margin: '48px 0 !important',
      transform: 'translateX(-50%) !important',
      gap: '8px !important',

      '& li': {
        margin: '0 !important',
      },
    },

    '& .carousel-control': {
      display: 'flex !important',
      width: '12px !important',
      margin: '12px 0 !important',
      left: '50% !important',
    },

    '& .carousel-control.left': {
      transform: ({ placements }) => {
        const transformations = [];

        // Move left arrow to the center
        transformations.push('translateX(-50%)');

        // Move left arrow to the left of the indicators
        const indicatorsWidth = getIndicatorsWidth(placements);
        transformations.push(`translateX(-${indicatorsWidth / 2}px)`);

        // Add extra space between the left arrow and the indicators
        transformations.push('translateX(-16px)');

        return transformations.join(' ');
      },
      bottom: '16px !important',
    },

    '& .carousel-control.right': {
      transform: ({ placements }) => {
        const transformations = [];

        // Move right arrow to the center
        transformations.push('translateX(-50%)');

        // Move right arrow to the right of the indicators
        const indicatorsWidth = getIndicatorsWidth(placements);
        transformations.push(`translateX(${indicatorsWidth / 2}px)`);

        // Add extra space between the right arrow and the indicators
        transformations.push('translateX(14px)');

        return transformations.join(' ');
      },
      bottom: '16px !important',
    },
  },
  disclaimerMessage: {
    maxWidth: '420px',
    fontSize: '12px',
    color: '#605E5C',
  },
  'disclaimerMessage-l': {
    width: '100%',
  },
  'disclaimerMessage-m': {
    width: '100%',
  },
  'disclaimerMessage-s': {
    width: '100%',
  },
  adPreviewActions: {
    display: 'flex',
    columnGap: '5px',
  },
});
